import React from 'react';

export default () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.75 12.1289L14.6953 4.18359L15.75 5.23828L6.75 14.2383L2.56641 10.0547L3.62109 9L6.75 12.1289Z" fill="currentColor" />
  </svg>
);
